const hasCaptchaErrors = (errors: DeserializeError) =>
  errors?.captcha?.includes('IS_REQUIRED');

export default hasCaptchaErrors;
